var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.field !== 'templateName' &&
    _vm.field !== 'clientId' &&
    _vm.field !== 'configLabel'
  )?_c('div',{staticClass:"field",class:[
    _vm.hasValue({
      field: _vm.field,
      category: _vm.category,
    }) && 'has-value',
    _vm.bulkDelete ? 'bulk-delete' : 'bulk-edit',
  ]},[_c('div',{staticClass:"question",attrs:{"id":_vm.id}},[(_vm.bulkDelete)?_c('bulkDeleteCheckbox',{attrs:{"fields":_vm.getBulkDeleteFields}}):_vm._e(),(_vm.field === 'logo')?_c('p',[_vm._v("Logo")]):_vm._e()],1),(!_vm.bulkDelete)?_c('div',{staticClass:"answer"},[(_vm.field === 'logo')?_c('logo',{attrs:{"id":_vm.bulkDelete ? 'bulkDelete' : 'bulkEdit',"category":_vm.category}}):_vm._e()],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }